import React, { useEffect, useState } from "react";

// List of all images to preload
const imagesToPreload = [
  "/assets/images/Mafia1.png",
  "/assets/images/DoctorSaveMe.png",
  "/assets/images/detective1.png",
  "/assets/images/MafiaKill.png",
  "/assets/images/VillagersDiscussion.png",
];

interface ImagePreloaderProps {
  children: React.ReactNode;
}

const ImagePreloader: React.FC<ImagePreloaderProps> = ({ children }) => {
  const [imagesLoaded, setImagesLoaded] = useState(false);

  useEffect(() => {
    let loadedCount = 0;
    const totalImages = imagesToPreload.length;

    const preloadImage = (src: string) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        loadedCount++;
        if (loadedCount === totalImages) {
          setImagesLoaded(true);
        }
      };
      img.onerror = () => {
        console.error(`Failed to load image: ${src}`);
        loadedCount++;
        if (loadedCount === totalImages) {
          setImagesLoaded(true);
        }
      };
    };

    // Start preloading all images
    imagesToPreload.forEach(preloadImage);

    // If no images to preload, set loaded to true
    if (totalImages === 0) {
      setImagesLoaded(true);
    }
  }, []);

  // Render loading state or children once images are loaded
  return (
    <>
      {!imagesLoaded && (
        <div className="fixed inset-0 bg-slate-900 flex items-center justify-center z-50">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500 mx-auto"></div>
            <p className="mt-4 text-indigo-300">Loading game resources...</p>
          </div>
        </div>
      )}
      {children}
    </>
  );
};

export default ImagePreloader;
